export class Quiz {
    constructor() {
    }

    init() {
        $('.quiz-button__answer').on('click', (e) => this.getAnswer(e));
        $('.quiz-button-next').on('click', (e) => this.nextQuestion(e));

        $('.is-hidden').hide();
    }

    // Handle answered question, show right/wrong answers
    getAnswer(e) {
        e.preventDefault();
        let pressedAnswer = $(e.currentTarget);
        let answeredId = pressedAnswer.data('id');

        let questionId = pressedAnswer.closest('.quiz-question').data('contentlink');
        let question = $('[data-contentlink=' + questionId + ']').first();
        let answerInfo = question.find('.quiz-question__answer-text').first();

        $.ajax({
            type: 'GET',
            url: '/api/quiz/getquizanswer/?questionId=' + questionId,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (data) {

                let answerInfoText = data[0];
                let correctAnswerId = data[1];

                if (answeredId == correctAnswerId) {
                    // User gave correct answer, add 1 to score
                    let currentScore = sessionStorage.getItem("quizScore");
                    if (!currentScore) {
                        currentScore = 0;
                    }

                    sessionStorage.setItem("quizScore", parseInt(currentScore) + 1);
                }
                else {
                    // Sorry, wrong answer
                    question.find('[data-id=' + answeredId + ']').addClass('wrong-answer');
                }
                question.find('[data-id=' + answeredId + ']').addClass('given-answer');
                question.find('[data-id=' + correctAnswerId + ']').addClass('right-answer');
                question.find('.quiz-button__answer').unbind();
                $('.quiz-button__answer').addClass('quiz-button__disabled');
                $('.quiz-button-next').show();
                $('.quiz-button-next').removeClass('quiz-button__disabled');
                answerInfo.show().html(answerInfoText);
            },
            error: function(error) {
                // Add error message to view
                answerInfo.show().html("Något gick fel, vi kunde inte hitta det rätta svaret.");
            }
        });
    }

    // Handle parts of page, start/questions/end-parts
    nextQuestion(e) {
        e.preventDefault();
        let button = $('.quiz-button-next');
        let currentIndex = button.data('index');
        let numberOfQuestions = $('#numberOfQuestions').val();

        let nextIndex = currentIndex + 1;
        let nextButtonText = "Nästa fråga";
        let nextButtonClass = "quiz-button-next__next";

        // Hide and show next part of page
        $('.quiz-question').hide();
        $('.quiz-end').hide();
        $('.quiz-question-' + nextIndex).show();
        $('.quiz-button__answer').show();

        if (currentIndex == 0) {
            // Reset score when starting a quiz
            sessionStorage.setItem("quizScore", 0);
        }

        if (nextIndex == numberOfQuestions) {
            // Last question, change button text
            nextButtonText = "Avsluta & se resultat";
            nextButtonClass = "quiz-button-next__last";
        }
        else if (nextIndex > numberOfQuestions) {
            // Reset index when quiz ends
            nextIndex = 0;
            currentIndex = 0;
            button.hide();
            $('.quiz-button__end').show();

            // Show result and end text
            let score = sessionStorage.getItem("quizScore");
            let endText = $('.quiz-end').html();
            let finalEndText = endText.replace("x/y", score + "/" + numberOfQuestions);
            $('.quiz-end').html(finalEndText).show();
        }

        if (nextIndex != 0 && nextIndex <= numberOfQuestions) {
            $('.quiz-button__answer').removeClass('quiz-button__disabled');
            button.addClass('quiz-button__disabled');
            button.hide();
        }
        button.removeClass('quiz-button-next__start');
        button.removeClass('quiz-button-next__next');
        button.removeClass('quiz-button-next__last');
        button.addClass(nextButtonClass);
        button.html(nextButtonText);
        button.data("index", nextIndex);
    }
}


// WEBPACK FOOTER //
// ./frontend/js/components/ost.quiz.js